import axios from 'axios';
import { API_BASE } from './apiConfig';

// gms_accountant-only; bearer token added automatically by the axios interceptor.
export const getGmsSpaces = () =>
  axios.get(`${API_BASE}/api/admin/gms-accountant/spaces`).then((r) => r.data);
